import React from "react"
import ReactDOM from "react-dom"
import { Provider } from 'react-redux'
import Store from "../../../store"

export default (cellComponent, row, props, col) => {
	return (instance, td, r, c, prop, value, cellProperties) => {
		ReactDOM.render(
			<Provider store={Store}>
				<cellComponent.component value={value} cellProperties={cellProperties} row={row} col={col} {...props} td={td}/>
			</Provider>, td)
		return td
	}
}



// WEBPACK FOOTER //
// ./src/component/scenarii/common/cell-renderer.js